'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

var Alerts = _interopRequireWildcard(_baseAlerts);

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STATUS_TYPES = (0, _keymirror2.default)({
  Success: null,
  Failure: null,
  Neutral: null
});

var propTypes = {
  message: _reactImmutableProptypes2.default.map.isRequired,
  values: _reactImmutableProptypes2.default.map,
  duration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
  clearMessages: _react.PropTypes.func.isRequired,
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  failureDuration: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
  useFormattedMessage: _react.PropTypes.bool,
  intl: _reactIntl.intlShape
};

var defaultProps = {
  duration: 10000,
  failureDuration: 10000
};

var Generic = function (_BcReactComponent) {
  _inherits(Generic, _BcReactComponent);

  function Generic(props) {
    _classCallCheck(this, Generic);

    var _this = _possibleConstructorReturn(this, (Generic.__proto__ || Object.getPrototypeOf(Generic)).call(this, props));

    _this.timeout = null;
    return _this;
  }

  _createClass(Generic, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleMessageClearance();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.timeout && nextProps.message !== this.props.message) {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.scheduleMessageClearance();
      }
    }
  }, {
    key: 'scheduleMessageClearance',
    value: function scheduleMessageClearance() {
      var _this2 = this;

      var _props = this.props,
          clearMessages = _props.clearMessages,
          duration = _props.duration,
          failureDuration = _props.failureDuration;

      if (duration) {
        var durationToUse = this.getAlertType() === STATUS_TYPES.Failure ? failureDuration : duration;
        this.timeout = setTimeout(function () {
          if (clearMessages) {
            clearMessages();
          }
          _this2.timeout = null;
        }, durationToUse);
      }
    }
  }, {
    key: 'getDefaultMessage',
    value: function getDefaultMessage() {
      if (this.props.message.get('defaultMessage')) {
        return this.props.message.get('defaultMessage');
      }

      if (this.getAlertType() === STATUS_TYPES.Failure) {
        return this.props.intl.formatMessage({ id: 'errors.ServiceException' });
      }

      return undefined;
    }
  }, {
    key: 'getAlertType',
    value: function getAlertType() {
      var type = this.props.message.get('type');
      var alertType = _lodash2.default.last(type.split('_'));
      return (0, _lodash2.default)(alertType.toLowerCase()).capitalize();
    }
  }, {
    key: 'render',
    value: function render() {
      var message = this.props.message;
      var extraValues = this.props.values || _immutable2.default.Map();
      var Component = Alerts['Alert' + this.getAlertType()];

      if (!Component) {
        return null;
      }

      var MessageComponent = this.props.useFormattedMessage ? _reactIntl.FormattedMessage : _reactIntl.FormattedHTMLMessage;

      return _react2.default.createElement(
        Component,
        null,
        _react2.default.createElement(MessageComponent, {
          id: message.get('id'),
          values: extraValues.merge(message.get('values', _immutable2.default.Map())).toJS(),
          defaultMessage: this.getDefaultMessage() })
      );
    }
  }]);

  return Generic;
}(_baseBcReactComponent2.default);

Generic.propTypes = propTypes;
Generic.defaultProps = defaultProps;

exports.default = (0, _reactIntl.injectIntl)(Generic);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-messages/lib/components/generic/components/Generic.component.js
// module id = 1493
// module chunks = 1